const price_page_first_list = [
  {
    features: "医美流程管理",
    professional: "yes",
    enterprise: "yes",
    flagship: "yes",
  },
  {
    features: "客户关系管理",
    professional: "yes",
    enterprise: "yes",
    flagship: "yes",
  },
  {
    features: "移动办公（APP）",
    professional: "yes",
    enterprise: "yes",
    flagship: "yes",
  },
  {
    features: "会员体系及权益",
    professional: "yes",
    enterprise: "yes",
    flagship: "yes",
  },
  {
    features: "供应链及仓储",
    professional: "yes",
    enterprise: "yes",
    flagship: "yes",
  },
  {
    features: "开发计划",
    professional: "yes",
    enterprise: "yes",
    flagship: "yes",
  },
  {
    features: "业绩管理",
    professional: "yes",
    enterprise: "yes",
    flagship: "yes",
  },
  {
    features: "会员中心",
    professional: "yes",
    enterprise: "yes",
    flagship: "yes",
  },
  {
    features: "电子病历及处方",
    professional: "yes",
    enterprise: "yes",
    flagship: "yes",
  },
  {
    features: "聚合支付",
    professional: "yes",
    enterprise: "yes",
    flagship: "yes",
  },
  {
    features: "语音识别及语义处理",
    professional: "yes",
    enterprise: "yes",
    flagship: "yes",
  },
];
const price_page_sec_list = [
  {
    features: "SCRM（自流量小程序）",
    professional: "",
    enterprise: "yes",
    flagship: "yes",
    rowSpan: 2,
    enter_content: '2选1',
    sub_title: '',
    pro_content: '',
    ship_content: ''
  },
  {
    features: "渠道分销",
    professional: "",
    enterprise: "yes",
    flagship: "yes",
    rowSpan: 0,
    pre_row_span: 2,
    enter_content: '',
    sub_title: '',
    pro_content: '',
    ship_content: ''
  },
  {
    features: "复单功能",
    professional: "",
    enterprise: "",
    flagship: "yes",
    rowSpan: 0,
    enter_content: '',
    sub_title: '',
    pro_content: '',
    ship_content: ''
  },
  {
    features: "智慧报表",
    sub_title: '（专业版、服务版）',
    professional: "",
    enterprise: "yes",
    flagship: "yes",
    rowSpan: 0,
    enter_content: '服务版',
    ship_content: '专业版',
    pro_content: '',
  },
  {
    features: "照片自动采集管理",
    sub_title: '',
    professional: "",
    enterprise: "yes",
    flagship: "yes",
    rowSpan: 0,
    enter_content: '',
    ship_content: '',
    pro_content: '',
  },
  {
    features: "3D实时建模",
    sub_title: '',
    professional: "",
    enterprise: "",
    flagship: "yes",
    rowSpan: 0,
    enter_content: '',
    ship_content: '',
    pro_content: '',
  },
  {
    features: "CA认证",
    sub_title: '',
    professional: "",
    enterprise: "",
    flagship: "",
    rowSpan: 0,
    enter_content: '',
    ship_content: '',
    pro_content: '',
  },
  {
    features: "云呼叫中心模块",
    sub_title: '（基础版/专业版/职能版）',
    professional: "yes",
    enterprise: "yes",
    flagship: "yes",
    rowSpan: 0,
    pro_content: '基础版',
    enter_content: '基础版',
    ship_content: '基础版'
  },
  {
    features: "可升级集团连锁版",
    sub_title: '',
    professional: "",
    enterprise: "yes",
    flagship: "yes",
    rowSpan: 0,
    pro_content: '',
    enter_content: '',
    ship_content: '',
    isLastTr: true,
    isLastTd: true
  },
];
function renderFirstRow() {
  return `
        <tr class="first_row">
            <td rowspan="12">
                <span>基础系统</span>
            </td>
        </tr>
        ${price_page_first_list
          .map((item) => {
            return `
                <tr>
                <td>${item.features}</td>
                <td ${item.professional?`class='bg_right'`:''}><div></div></td>
                <td ${item.enterprise?`class='bg_right'`:''}></td>
                <td ${item.flagship?`class='bg_right'`:''}></td>
                </tr>
                `;
          })
          .join("")}
    `;
}

function renderSecRow() {
  return `
  <tr class="first_row">
        <td rowspan="10" class="price_bottom_left_radius"><span>增值功能</span></td>
   </tr>
  ${price_page_sec_list.map(item => {
      const {features,professional,sub_title,enterprise,flagship,rowSpan,pro_content,enter_content,ship_content} = item
      return `
      <tr ${item['isLastTr']?"class='last_tr'":''}>
                    <td>${sub_title?features+`<span class="fs-12">${sub_title}</span>`:features}</td>
                    <td ${professional?'':"class='price_no_content'"}>
                    ${professional?pro_content:'-'}</td>
                    <td ${enterprise?(enter_content?'':`class='bg_right'`):"class='price_no_content'"} ${rowSpan?`rowspan=${rowSpan}`:''}>${enterprise?(enter_content?enter_content:''):'-'}</td>
                      ${item['pre_row_span']?'':`<td ${item['isLastTd']?"class='last_td bg_right'":(ship_content?'':`class='bg_right'`)} ${flagship?'':"class='price_no_content'"}>${flagship?(ship_content?ship_content:''):'-'}</td>`}
                  </tr>
                  `
  }).join('')}
  `;
}
export { renderFirstRow, renderSecRow };
